export const white = '#fff';

export const gray100 = '#f4f6f9';
export const gray200 = '#ebeef2';
export const gray300 = '#d8dbdf';
export const gray600 = '#c2c5cc';
export const gray700 = '#8c9099';
export const gray800 = '#626366';
export const gray900 = '#333';

export const primary50 = 'var(--primary-50)';
export const primary100 = 'var(--primary-100)';
export const primary200 = 'var(--primary-200)';
export const primary300 = 'var(--primary-300)';
export const primary400 = 'var(--primary-400)';
export const primary500 = 'var(--primary-500)';
export const primary600 = 'var(--primary-600)';
export const primary700 = 'var(--primary-700)';
export const primary800 = 'var(--primary-800)';
export const primary900 = 'var(--primary-900)';
export const primary = 'var(--primary-1000)';

export const secondary50 = 'var(--secondary-50)';
export const secondary100 = 'var(--secondary-100)';
export const secondary200 = 'var(--secondary-200)';
export const secondary300 = 'var(--secondary-300)';
export const secondary400 = 'var(--secondary-400)';
export const secondary600 = 'var(--secondary-600)';
export const secondary = 'var(--secondary-800)';
export const secondary1000 = 'var(--secondary-1000)';

export const tertiaryOriginal200 = '#fde587';
export const tertiaryOriginal300 = '#fcdf6d';
export const tertiaryOriginal400 = '#f9d65a';
export const tertiaryOriginal600 = '#f8c35a';
export const tertiaryOriginal800 = '#f4a359';
export const tertiaryOriginal = '#f28d3c';

export const tertiary200 = 'var(--tertiary-200)';
export const tertiary300 = 'var(--tertiary-300)';
export const tertiary400 = 'var(--tertiary-400)';
export const tertiary600 = 'var(--tertiary-600)';
export const tertiary800 = 'var(--tertiary-800)';
export const tertiary = 'var(--tertiary-1000)';

export const danger100 = '#fff2f2';
export const danger200 = '#ffd4d2';
export const danger300 = '#ffb9b1';
export const danger400 = '#ff856f';
export const danger500 = '#ff5f37';
export const danger600 = '#ff470d';
export const danger700 = '#e82a00';
export const danger800 = '#cb1800';
export const danger900 = '#aa0a00';

export function cssvar(name) {
  // Extracts CSS variable:
  // 1. Changes "var(--test)" into "--test".
  // 2. Returns values of "--test" CSS variable.
  return getComputedStyle(document.documentElement).getPropertyValue(
    name.replace(/(var\()|(\))/g, ''),
  );
}
